import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/utility/auth/auth.service';

import { CatalogConfigListComponent } from '@serengeti/serengeti-resource';
import { CatalogConfigDetailComponent } from '@serengeti/serengeti-resource';

import { AppComponent } from 'src/app/app.component';

import { TaskScheduleListComponent } from '../app/setting/task/scheduler/list/list.component';
import { TaskScheduleDetailComponent } from '../app/setting/task/scheduler/detail/detail.component';
import { TaskScheduleVariableListComponent } from '../app/setting/task/scheduler/variable/list/list.component';
import { TaskScheduleVariableDetailComponent } from '../app/setting/task/scheduler/variable/detail/detail.component';

import { BillingCloudListComponent } from '@serengeti/serengeti-billing';
import { BillingCloudDetailComponent } from '@serengeti/serengeti-billing';

import { LogListComponent } from 'src/app/setting/log/list/list.component';

import {
	MailHistoryDetailComponent,
	MailHistoryListComponent,
	MailRequestComposeComponent,
	MailSettingConfigComponent,
	MailTemplateDetailComponent,
	MailTemplateListComponent
} from '@serengeti/serengeti-mailer';

import {
	TaskConfigListComponent,
	TaskConfigDetailComponent
} from '@serengeti/serengeti-task';
import { CodeDetailComponent, CodeListComponent } from "@serengeti/serengeti-code";
import {ConfigDetailComponent, ConfigListComponent} from "@serengeti/serengeti-config";
import {UserDetailComponent, UserListComponent} from "@serengeti/serengeti-user";
import { OrderApproveComponent } from '@serengeti/serengeti-order';


const routes: Routes = [
	{ path: 'main', component: AppComponent, canActivate: [AuthService], children: [

		{ path: 'setting/user/list', component: UserListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.user.list.title', root: true }  },
		{ path: 'setting/user/create', component: UserDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.user.create.title' } },
		{ path: 'setting/user/detail/:id', component: UserDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.user.detail.title' } },
		{ path: 'setting/groupCode/list', component: CodeListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.code.list.title', root: true } },
		{ path: 'setting/groupCode/create', component: CodeDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.code.create.title' } },
		{ path: 'setting/groupCode/:id', component: CodeDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.code.detail.title'}},

		{ path: 'setting/config/list', component: ConfigListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.config.list.title', root: true } },
		{ path: 'setting/config/create', component: ConfigDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.config.create.title'}  },
		{ path: 'setting/config/detail/:id', component: ConfigDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.config.detail.title'} },

		{ path: 'setting/log/list', component: LogListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.log.list.title', root: true } },
		{ path: 'order/approve/list', component: OrderApproveComponent, outlet: 'content', data: { title: 'lib.order.approve.list.title', root: true } },

		// 메뉴 호환성을 위해서 라우팅을 동일하게 하나 추가
		{ path: 'service/scheduler/job/list', component: TaskScheduleListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.task.schedule.list.title', root: true } },
		{ path: 'setting/task/schedule/list', component: TaskScheduleListComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'setting.task.schedule.list.title', root: true } },
		{ path: 'setting/task/schedule/create', component: TaskScheduleDetailComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'setting.task.schedule.create.title' } },
		{ path: 'setting/task/schedule/detail/:id/', component: TaskScheduleDetailComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'setting.task.schedule.detail.title' } },
		{ path: 'setting/task/schedule/variable/list', component: TaskScheduleVariableListComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'setting.task.schedule.variable.list.title' } },
		{ path: 'setting/task/schedule/variable/create', component: TaskScheduleVariableDetailComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'setting.task.schedule.variable.create.title' } },
		{ path: 'setting/task/schedule/variable/detail/:id/', component: TaskScheduleVariableDetailComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'setting.task.schedule.variable.detail.title' } },

		{ path: 'task/config/list', component: TaskConfigListComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'lib.task.config.list.title', root: true } },
		{ path: 'task/config/create', component: TaskConfigDetailComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'lib.task.config.create.title' } },
		{ path: 'task/config/detail/:id/', component: TaskConfigDetailComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'lib.task.config.detail.title' } },

		{ path: 'setting/catalog/config/list', component: CatalogConfigListComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'setting.catalog.config.list.title', root: true } },
		{ path: 'setting/catalog/config/create', component: CatalogConfigDetailComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'setting.catalog.config.create.title' } },
		{ path: 'setting/catalog/config/detail/:id/', component: CatalogConfigDetailComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'setting.catalog.config.detail.title' } },

		{ path: 'mailer/template/list', component: MailTemplateListComponent, outlet: 'content', data: { title: 'lib.mailer.template.list.title', root: true } },
		{ path: 'mailer/template/create', component: MailTemplateDetailComponent, outlet: 'content', data: { title: 'lib.mailer.template.create.title', root: false } },
		{ path: 'mailer/template/detail/:id/', component: MailTemplateDetailComponent, outlet: 'content', data: { title: 'lib.mailer.template.detail.title', root: false } },
		{ path: 'mailer/history/list', component: MailHistoryListComponent, outlet: 'content', data: { title: 'lib.mailer.history.list.title', root: true } },
		{ path: 'mailer/history/detail/:id/', component: MailHistoryDetailComponent, outlet: 'content', data: { title: 'lib.mailer.history.detail.title', root: false} },
		{ path: 'mailer/request/compose', component: MailRequestComposeComponent, outlet: 'content', data: { title: 'lib.mailer.request.compose.title', root: true } },
		{ path: 'mailer/setting/config', component: MailSettingConfigComponent, outlet: 'content', data: { title: 'lib.mailer.setting.config.title', root: true } },
	]}
];

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
		CommonModule
	]
})
export class AppRoutingSettingModule { }
